import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getActivateLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const ActivateHistory = (props) => {
  const [activateHistory, setActivateHistory] = useState([]);
  const { activate_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getActivateLog(activate_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setActivateHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Activate Log
        </Typography>
      </Box>

      {response && activateHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ESN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Plan ID</TableCell>
                    <TableCell align="left">Zipcode</TableCell>
                    <TableCell align="left">MDN</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {activateHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/pwg/activate/batch/${activateHistory.data.batch_id}`}
                      >
                        {activateHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={activateHistory.data.status}
                        size="small"
                        color={getChipColor(activateHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {activateHistory.data.plan_id || activateHistory.data.plan}
                    </TableCell>
                    <TableCell align="left">
                      {activateHistory.data.zipcode}
                    </TableCell>
                    <TableCell align="left">
                      {activateHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      {activateHistory.data.last_updated &&
                        `${format(
                          new Date(activateHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {activateHistory.data.extra_data?.is_esim ? (
            <Box
              sx={{ width: "100%", mb: 5 }}
              display="flex"
              alignItems="center"
              flexDirection="column"
            >
              <Box mb={2}>
                <Typography variant="h6" align="left">
                  eSIM
                </Typography>
              </Box>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">IMSI</TableCell>
                      <TableCell align="left">PIN1</TableCell>
                      <TableCell align="left">PUK1</TableCell>
                      <TableCell align="left">PIN2</TableCell>
                      <TableCell align="left">PUK2</TableCell>
                      <TableCell align="left">QR Activation Code</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="left">
                        {activateHistory.data.extra_data.esim_imsi || "-"}
                      </TableCell>
                      <TableCell align="left">
                        {activateHistory.data.extra_data.esim_pin1 || "-"}
                      </TableCell>
                      <TableCell align="left">
                        {activateHistory.data.extra_data.esim_puk1 || "-"}
                      </TableCell>
                      <TableCell align="left">
                        {activateHistory.data.extra_data.esim_pin2 || "-"}
                      </TableCell>
                      <TableCell align="left">
                        {activateHistory.data.extra_data.esim_puk2 || "-"}
                      </TableCell>
                      <TableCell align="left" sx={{ wordBreak: "break-all" }}>
                        {activateHistory.data.extra_data
                          .esim_qr_activation_code || "-"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : (
            ""
          )}
          <ApiLogHistory data={activateHistory.history?.data || []} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ActivateHistory;
